import { REACT_QUERY_KEYS } from '@/constants'

export type CustomKeySettingsSelectQueryParams = {
  tenantKey: string
  dcId: number
}

export const customKeySettingsQueryKeys = {
  all: [REACT_QUERY_KEYS.CUSTOM_KEY_SETTINGS] as const,
  select: (params: CustomKeySettingsSelectQueryParams) =>
    [...customKeySettingsQueryKeys.all, 'select', params] as const
}
